import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'SISM-AngularManager';
userIsLoaded: boolean = false;
  userLoaded($event: boolean) {
    this.userIsLoaded = $event;
  }
}
